import Divider from "@mui/material/Divider";
import MenuItem from "@mui/material/MenuItem";
import useLocales from "src/hooks/useLocales";
import useResponsive from "src/hooks/useResponsive";

import LanguageImage from "./LanguageImage";

export default function LanguagePopoverItems({ onClick }: { onClick: () => void }) {
	const isSm = useResponsive("down", "sm");
	const { allLang, currentLang, onChangeLang, translate } = useLocales();

	const handleOnChangeLang = (newLang: string) => {
		if (newLang !== currentLang.value) {
			onChangeLang(newLang);
			//dispatch(updateUserLanguajeRequestAction(newLang))
		}
		onClick();
	};

	const width = isSm ? 36 : 28;

	return (
		<>
			{allLang.map((option, index) => (
				<>
					<MenuItem
						key={option.value}
						onClick={() => handleOnChangeLang(option.value)}
						selected={option.value === currentLang.value}
					>
						<LanguageImage url={option.icon} sx={{ width, mr: 2 }} />
						{translate(`languages.${option.label}`)}
					</MenuItem>
					{isSm && !(index / 2) && <Divider sx={{ borderStyle: "dashed" }} />}
				</>
			))}
		</>
	);
}
